import { render } from "./MianSlider.vue?vue&type=template&id=2c660570"
import script from "./MianSlider.vue?vue&type=script&lang=js"
export * from "./MianSlider.vue?vue&type=script&lang=js"

import "./MianSlider.vue?vue&type=style&index=0&id=2c660570&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__